import { render, staticRenderFns } from "./SamIconList.vue?vue&type=template&id=52e7a02e&scoped=true&shadow"
import script from "./SamIconList.vue?vue&type=script&lang=js&shadow"
export * from "./SamIconList.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamIconList.vue?vue&type=style&index=0&id=52e7a02e&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "52e7a02e",
  null
  ,true
)

export default component.exports